/* eslint-disable no-underscore-dangle */
import Renderer from "./environment-renderer";

const EventEmitter = require("events");
const _ = require("lodash");

const PlatformSdk = require("@gluenetworks/platform-sdk-remote");

const DeviceEntity = PlatformSdk.entities.ws.Device;

class EnvironmentComponent extends EventEmitter {
    constructor(value) {
        super();

        this._deviceEntity = DeviceEntity;
        this._value = value;
        this._renderer = new Renderer(this);
        this._registerListeners();
    }

    /********************************************/
    /* START PRIVATE COMPONENT MODEL METHODS    */
    /********************************************/

    _registerListeners() {}

    _unregisterListeners() {}

    /********************************************/
    /* END PRIVATE COMPONENT MODEL METHODS      */
    /* START PUBLIC COMPONENT MODEL METHODS     */
    /********************************************/

    get renderer() {
        return this.getRenderer();
    }

    getRenderer() {
        return this._renderer;
    }

    shutdown() {
        this._unregisterListeners();
        const prom = this._renderer._shutdown();
        this._renderer = undefined;
        this._value = undefined;
        return prom;
    }

    /********************************************/
    /* END COMPONENT MODEL METHODS              */
    /* START HANDLER METHODS                    */
    /********************************************/

    /********************************************/
    /* END HANDLER METHODS                      */
    /* START PRIVATE METHODS                    */
    /********************************************/

    /********************************************/
    /* END PRIVATE METHODS                      */
    /* START PUBLIC API METHODS                 */
    /********************************************/

    setValue() {
        this.emit("Update", this._value);
    }

    getEnvironmentTitle() {
        return this._deviceEntity.getEnvironmentLabels()[this._value];
    }

    /********************************************/
    /* END PUBLIC API METHODS                   */
    /********************************************/
}

export default EnvironmentComponent;
